import { otto } from "../../exports/nexus.js";
import {
  runWithMicrotask,
  runWithMacrotask,
  runWithAnimationFrame,
  runWithRenderSlice,
} from "./async/promise";

otto.grcore.assignNamespace({
  runWithMicrotask,
  runWithMacrotask,
  runWithAnimationFrame,
  runWithRenderSlice,
});
